import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=7af29620&scoped=true"
import script from "./layout-footer.vue?vue&type=script&lang=js"
export * from "./layout-footer.vue?vue&type=script&lang=js"
import style0 from "./layout-footer.vue?vue&type=style&index=0&id=7af29620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af29620",
  null
  
)

export default component.exports